import {default as cx} from "classnames"
import {Question} from "./shared/Question"
import {ScaleLegend} from "./shared/ScaleLegend"

const DEFAULT_ANSWERS = [
    {label: "1", value: "1", title: "Strongly Disagree"},
    {label: "2", value: "2", title: "Disagree"},
    {label: "3", value: "3", title: "Agree"},
    {label: "4", value: "4", title: "Strongly Agree"},
    {label: "0", value: "0", title: "Not Applicable"},
]

const CaseyFink = ({
    questionText,
    field,
    options,
    questionNumber,
    totalQuestions,
    currentQuestion,
    data,
    emptyError,
    handle,
    sectionName,
    isRequired = true,
}) => {
    const answers = options ?? DEFAULT_ANSWERS

    return (
        <>
            {sectionName && <div className="text-primary d-flex fs-6 fw-bold">{sectionName}:</div>}
            <Question questionText={questionText} questionNumber={questionNumber} totalQuestions={totalQuestions} isRequired={isRequired} />
            <div className="w-100 py-5">
                <ScaleLegend first="Strongly Disagree" last="Strongly Agree" />
                <div className="d-flex flex-wrap w-100">
                    {answers.map((option, index) => {
                        const id = `${field}-${index}`
                        const checked = option.value === data
                        const hoverTitle = DEFAULT_ANSWERS.find((f) => f.label === option.label)?.title ?? "";
                        let labelClass = "flex-fill flex-center px-0"
                        let label = option.label;
                        if (option.label === '0') {
                            label = 'N/A'
                            labelClass = "justify-content-center align-items-center w-100 mt-2"
                        }

                        return (
                            <label
                                className={cx(
                                    "btn d-flex btn-outline btn-active-primary ",
                                    labelClass,
                                    emptyError ? "border-danger" : "",
                                    {active: checked}
                                )}
                                title={hoverTitle}
                                htmlFor={id}
                                key={id}
                            >
                                <input
                                    id={id}
                                    type="radio"
                                    className="btn-check"
                                    name={field}
                                    value={option.value}
                                    checked={checked}
                                    onChange={(evt) => handle(evt.target.value)}
                                />
                                {label}
                            </label>
                        )
                    })}
                </div>
                <div className="text-center py-3">Casey-Fink Graduate Nurse Experience Survey &#169; 2023</div>
            </div>
            {emptyError && isRequired && <span className="text-danger mt-n5">Selection is required</span>}
        </>
    )
}

export default CaseyFink
